import {http} from "../http";

export interface TransactionApprove{
    trnRequestType : string; //"SIGN" | "APPROVE" | "SAVE";
    fileDescriptors? : any;
}

export const sendTransactionApprove = async (request_data : TransactionApprove): Promise<TransactionApprove> => {    
    const { data } = await http.post<TransactionApprove>("transaction/approve", request_data);
    return data;
};

export const sendTransactionSendToBank = async (request_data : TransactionApprove): Promise<TransactionApprove> => {
    const { data } = await http.post<TransactionApprove>("transaction/send-to-bank", request_data);
    return data;
};
